// Async boundary for Module Federation: the app's shared modules (React, MUI)
// must be negotiated with any host before they are first used.
import('./bootstrap');

export {};
